import { ScreeningStatus } from "shared/types";

export const screeningStatusTitle = (status?: string) => {
  switch (status) {
    case ScreeningStatus.Processing:
      return "In progress";
    case ScreeningStatus.Completed:
      return "Complete";
    case ScreeningStatus.Failed:
      return "Error";
    default:
      return "Not started";
  }
};
